import { render, staticRenderFns } from "./FeaturedArticles.vue?vue&type=template&id=8a7fbfc6&scoped=true&"
import script from "./FeaturedArticles.vue?vue&type=script&lang=js&"
export * from "./FeaturedArticles.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedArticles.vue?vue&type=style&index=0&id=8a7fbfc6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7fbfc6",
  null
  
)

export default component.exports